import { Text, TextProps } from "@chakra-ui/react"

interface ThemedTextProps extends TextProps{
  weight?: 'regular' | 'medium' | 'semibold'
}
export function ThemedText({
  style,
  weight = 'regular',
  className,
  ...rest
}: ThemedTextProps) {
  // const color = useThemeColor({ light: lightColor, dark: darkColor }, 'text');
  const fontFamily = {
    regular: 'Poppins-Regular',
    medium: 'Poppins-Medium',
    semibold: 'Poppins-SemiBold',
  }[weight]
  return (
    <Text
      color="text.t1"
      fontFamily={fontFamily}
      {...rest}
    />
  )
}
